import { isURL } from 'validator';

import { extend } from 'vee-validate';
import { required, email, url } from 'vee-validate/dist/rules';

extend('required', {
    ...required,
    message: '{_field_} ist eine Pflichtangabe'
});

extend('email', {
    ...email,
    message: 'Dies ist keine gültige E-Mail Adresse'
});

extend('url', {
    validate: url => isURL(url, { protocols: ['http', 'https'], require_protocol: true }),
    message: 'Dies ist keine gültige URL'
});

extend('password', {
    params: ['score'],
    validate(value, { score }) {
        return value && score >= 3;
    },
    // message: 'Passwortstärke muss im grünen Bereich liegen'
    message: 'Passwort ist nicht sicher genug'
});

export const translateSuggestion = suggestion => {
    let translation = suggestion;
    switch (suggestion) {
        case 'Use a few words, avoid common phrases':
            translation = 'Benutzen Sie einige Wörter und vermeiden Sie dabei gebräuchliche Sätze';
            break;
        case 'No need for symbols, digits, or uppercase letters':
            translation = 'Es gibt keine Notwendigkeit für Symbole, Ziffern oder Großbuchstaben';
            break;
        case 'Add another word or two. Uncommon words are better.':
            translation = 'Fügen Sie ein oder zwei weitere Wörter hinzu. Ungewöhnliche Wörter sind besser.';
            break;
        case 'Use a longer keyboard pattern with more turns':
            translation = 'Verwenden Sie ein längeres und komplizierteres Tastaturmuster';
            break;
        case 'Avoid repeated words and characters':
            translation = 'Vermeiden Sie sich wiederholdende Wörter und Zeichen';
            break;
        case 'Avoid sequences':
            translation = 'Vermeiden Sie Abfolgen';
            break;
        case 'Avoid recent years':
            translation = 'Vermeiden Sie die letzten Jahre';
            break;
        case 'Avoid years that are associated with you':
            translation = 'Vermeiden Sie Jahre, die mit Ihnen in Verbindung stehen';
            break;
        case 'Avoid dates and years that are associated with you':
            translation = 'Vermeiden Sie Jahre oder Daten, die mit Ihnen in Verbindung stehen';
            break;
        case "Capitalization doesn't help very much":
            translation = 'Großschreibung hilft nicht besonders viel';
            break;
        case 'All-uppercase is almost as easy to guess as all-lowercase':
            translation = 'Großbuchstaben sind fast so leicht zu erraten wie Kleinbuchstaben';
            break;
        case "Reversed words aren't much harder to guess":
            translation = 'Wörter sind rückwärts fast genau so leicht zu erraten, wie vorwärts';
            break;
        case "Predictable substitutions like '@' instead of 'a' don't help very much":
            translation = "Vorhersehbare Substitutionen wie '@' anstelle von 'a' helfen nicht viel";
            break;
    }

    return translation;
};

export const translateWarnings = warning => {
    let translation = warning;
    switch (warning) {
        case 'Straight rows of keys are easy to guess':
            translation = 'Gerade Tastenreihen sind leicht zu erraten';
            break;
        case 'Short keyboard patterns are easy to guess':
            translation = 'Kurze Tastaturmuster sind leicht zu erraten';
            break;
        case 'Repeats like "aaa" are easy to guess':
            translation = 'Wiederholungen wie "aaa" sind leicht zu erraten';
            break;
        case 'Repeats like "abcabcabc" are only slightly harder to guess than "abc"':
            // 'Wiederholungen wie "abcabcabc" sind nur wenig schwieriger zu erraten als "abc"';
            translation = 'Wiederholungen wie "abcabcabc" sind leicht zu erraten';
            break;
        case 'Sequences like abc or 6543 are easy to guess':
            translation = 'Abfolgen wie abc, oder 6543 sind leicht zu erraten';
            break;
        case 'Recent years are easy to guess':
            translation = 'Die letzten Jahre sind leicht zu erraten';
            break;
        case 'Dates are often easy to guess':
            translation = 'Ein Datum ist oft leicht zu erraten';
            break;
        case 'This is a top-10 common password':
            translation = 'Dies ist ein Top-10 häufig verwendetes Passwort';
            break;
        case 'This is a top-100 common password':
            translation = 'Dies ist ein Top-100 häufig verwendetes Passwort';
            break;
        case 'This is a very common password':
            translation = 'Dies ist ein sehr häufig verwendetes Passwort';
            break;
        case 'This is similar to a commonly used password':
            translation = 'Dies ähnelt einem häufig verwendeten Passwort';
            break;
        case 'A word by itself is easy to guess':
            translation = 'Ein einzelnes Wort ist leicht zu erraten';
            break;
        case 'Names and surnames by themselves are easy to guess':
            translation = 'Namen und Nachnamen sind leicht zu erraten';
            break;
        case 'Common names and surnames are easy to guess':
            translation = 'Weit verbreitete Namen und Nachnamen sind leicht zu erraten';
            break;
    }

    return translation;
};
